import React from 'react';
import { transactionItem } from '../styling/style-classes';

const NotificationDot = () => (
    <div className={transactionItem.notificationDot}></div>
);

export default NotificationDot;
